export const FLAG_GETTING_ACTIVITY_TASKS = 'FLAG_GETTING_ACTIVITY_TASKS';
export const GET_ACTIVITY_TASKS = 'GET_ACTIVITY_TASKS';
export const CLEAR_ACTIVITY_TASKS = 'CLEAR_ACTIVITY_TASKS';
export const FLAG_ACTIVITY_TASK_ACTIVITY = 'FLAG_ACTIVITY_TASK_ACTIVITY';
export const GET_ACTIVITY_TASK = 'GET_ACTIVITY_TASK';
export const CLEAR_ACTIVITY_TASK = 'CLEAR_ACTIVITY_TASK';
